module.exports = __webpack_public_path__ + "img/runway.84669a99.svg";